import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Auth } from '../auth.service';

@Component({
  selector: 'cw-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
  email: string;
  password: string;
  token: string;
  errorMessage: string;

  constructor(private  route: ActivatedRoute,
              private auth: Auth) {
  }

  ngOnInit() {
    this.route.params
      .subscribe((params: Params) => {
        this.token = params['token'];
      });
  }

  reset() {
    this.auth.resetPassword(this.email, this.password, this.token).subscribe(ok => {
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/reset-password/reset-password.component.ts